import React, { useEffect, useState } from 'react'
import { firestore } from '../../../firebase'
import ImageGrid from '../Media/ImageGrid'

function EditPlayerSquadForm({ playerId, teamId, player }) {
    const [name, setName] = useState('')
    const [image, setImage] = useState(player?.player_image)

    const [position, setPosition] = useState('2')
    const [playerParentId, setPlayerParentId] = useState('')
    const [playerNumber, setPlayerNumber] = useState('99')
    const [showImage, setShowImage] = useState(false)

    const [message, setMessage] = useState('')

    useEffect(() => {
        if (player) {
            setName(player.player_name)
            setImage(player.player_image)
            setPosition(player.position || '2')
            setPlayerParentId(player.player_parent_id || '0')
            setPlayerNumber(player.player_number || '99')
        }
    }, [player])

    function imageToggler() {
        if (showImage) {
            setShowImage(false)
        } else {
            setShowImage(true)
        }
    }

    async function editHandler(e) {
        const data = {
            player_name: name,
            player_image: image,
            position: position,
            player_number: playerNumber,
            player_parent_id: playerParentId,
        }
        e.preventDefault()
        try {
            const playerSquadRef = firestore
                .collection('teams')
                .doc(teamId)
                .collection('players')
                .doc(playerId)

            console.log(data, 'DATA FORM')
            playerSquadRef.update(data)
            setMessage('Oppdatert!')
        } catch (error) {
            setMessage('Kunne ikke oppdatere')
            console.log(data, 'DATA FORM')
            console.log(error)
        }
    }

    function formatPosition(posNo) {
        const positions = ['Keeper', 'Forsvar', 'Midtbane', 'Angrep']
        return positions[posNo - 1]
    }

    return (
        <div className="my-3">
            <form onSubmit={editHandler}>
                <label>Navn</label>
                <input
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="form-control mb-2"
                />

                <label>Nummer</label>
                <input
                    value={playerNumber}
                    onChange={(e) => setPlayerNumber(e.target.value)}
                    className="form-control mb-2"
                />

                <label>Spiller ID</label>
                <input
                    value={playerParentId}
                    onChange={(e) => setPlayerParentId(e.target.value)}
                    className="form-control mb-2"
                />

                <label>Posisjon (Gjeldende: {position})</label>
                <select
                    onChange={(e) => setPosition(e.target.value)}
                    className="browser-default custom-select"
                >
                    {position && (
                        <option value={position}>
                            {formatPosition(position)}
                        </option>
                    )}
                    <option value="1">Keeper</option>
                    <option value="2">Forsvar</option>
                    <option value="3">Midtbane</option>
                    <option value="4">Angrep</option>
                </select>

                <button
                    className="btn btn-rounded btn-sm btn-success"
                    onClick={imageToggler}
                >
                    Velg bilde fra galleri
                </button>
                {showImage && (
                    <ImageGrid
                        setSelectedImg={setImage}
                        setShowImage={setShowImage}
                    />
                )}

                <label>Bilde url</label>
                <input
                    value={image}
                    onChange={(e) => setImage(e.target.value)}
                    className="form-control mb-2"
                />
                <div className="col-4">
                    <img
                        src={image}
                        className="img-fluid"
                        style={{ maxWidth: '100px' }}
                    />
                </div>
                <br />
                {message && <p>{message}</p>}
                <button className="btn btn-primary btn-rounded">
                    Lagre endringer
                </button>
                <br />
            </form>
        </div>
    )
}
export default EditPlayerSquadForm
